const PROFILE_KEY = 'ark-profile'

const emptyProfile = {
  name: '', email: '', phone: '', location: '',
  linkedin: '', github: '', website: '', summary: '',
  experience: [], education: [], skills: [],
}

export const loadProfile = () => {
  try {
    const stored = localStorage.getItem(PROFILE_KEY)
    if (stored) return { ...emptyProfile, ...JSON.parse(stored) }
  } catch (err) { console.error('Error loading profile:', err) }
  return { ...emptyProfile }
}

export const saveProfile = (profile) => {
  try { localStorage.setItem(PROFILE_KEY, JSON.stringify(profile)) }
  catch (err) { console.error('Error saving profile:', err) }
}

export const hasProfile = () => {
  const p = loadProfile()
  return !!(p.name && p.email && p.experience.length > 0)
}

export { emptyProfile }
